import endoflife from "../../img/info/end_of_life.png";
import "./Information.css";

const EndOfLifePage = () => {
    return (
      <div className="info_container">
        <h1>End-of-Life (EOL) Emissions</h1>
        <h2>Overview</h2>
        <p>The end-of-life (EOL) phase of pavement involves activities such as demolition, removal, recycling, and disposal of pavement materials. This phase contributes to greenhouse gas (GHG) emissions due to the energy required for these processes and the potential release of stored carbon. This page provides an overview of the emissions associated with the EOL phase of pavements.</p>
        <figure className="figure">
            <img src={endoflife} alt="End Of Life" />
            <figcaption>Figure 1 Break down of pavement’s whole life-cycle stages </figcaption>
        </figure>
        <h2>End-of-Life Activities</h2>
        <p>The EOL phase of pavement includes several key activities, each with associated emissions:</p>
        <ul>
          <li><b>C1 - Demolition and Removal:</b> Breaking up and removing the existing pavement using heavy machinery.</li>
          <li><b>C2 - Transportation:</b> Hauling demolished materials to recycling or disposal sites.</li>
          <li><b>C3 - Recycling and Reuse:</b> Processing reclaimed asphalt pavement (RAP) or crushed concrete for reuse in new pavement projects.</li>
          <li><b>C4 - Disposal:</b> Landfilling or stockpiling materials that cannot be recycled.</li>
        </ul>
        <h2>Impact on GHG Emissions</h2>
        <p>EOL activities contribute to GHG emissions through various mechanisms:</p>
        <ul>
          <li><b>Energy Consumption:</b> Operation of demolition equipment, transportation vehicles, and recycling machinery consumes energy, leading to direct emissions.</li>
          <li><b>Material Processing:</b> Recycling processes, such as crushing and screening of reclaimed materials, require energy and emit GHGs.</li>
          <li><b>Carbon Release:</b> Disturbance of carbonated concrete during demolition can release stored CO2 back into the atmosphere.</li>
          <li><b>Landfill Emissions:</b> Decomposing organic materials in landfills can generate methane (CH4), a potent GHG.</li>
        </ul>
      </div>
    );
  }
  
  export default EndOfLifePage;